import { MouseEvent } from 'react';

import type { HelpPageContent } from 'components/help_sidebar/HelpSidebar';
import { DropdownItem, type DropdownItemProps } from 'react-bootstrap';
import { useHelpSidebar } from 'components/help_sidebar/context';
import { FormattedMessage, useIntl } from 'react-intl';
import { useApp } from 'app';

import 'components/help_sidebar/components/trigger/styles/HelpSidebarTrigger.scss';

type HelpSidebarTriggerProps = Omit<DropdownItemProps, 'content'> & {
    content: HelpPageContent;
    icon?: string;
}

export const HelpSidebarDropdownTrigger = (props: HelpSidebarTriggerProps) => {

    const { formatMessage } = useIntl();

    const { className, content, onClick, ...rest } = props;

    const { isFeatureEnabled } = useApp();
    const { show, visible } = useHelpSidebar();

    const handleClick = (e: MouseEvent<HTMLButtonElement>) => {

        show(content);
        onClick?.(e);

    };

    if (!isFeatureEnabled('Admin.General.HelpSidebar')) return null;

    return (
        <DropdownItem
            aria-expanded={visible}
            aria-label={formatMessage({ id: 'open_help_sidebar.debff65e', defaultMessage: 'Open help sidebar' })}
            className={`help-sidebar-dropdown-trigger ${className ?? ''}`.trim()}
            onClick={handleClick}
            {...rest}
        >
            <FormattedMessage defaultMessage="Help" id="help.1279c64f" />
        </DropdownItem>
    );

};